import styled, { css } from "styled-components";

const NavBar = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  padding: 14px 25px 10px;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  ${({ home }) =>
    !home &&
    css`
      border-top: 1px solid #eeeeee;
      background-color: #fcfcfc;
    `};
`;

export default NavBar;
